/**
 * The reaction picker's five defaults, and the pure "tap replaces, tap-your-
 * own clears" toggle rule (ISSUE-280 plan §5.10).
 */

export const DEFAULT_REACTION_EMOJI = ["👍", "👎", "😂", "🤩", "🤯"] as const;

export function resolveReactionTap(input: {
  currentReaction: string | null;
  tappedEmoji: string;
}): string | null {
  if (input.tappedEmoji === input.currentReaction) {
    return null;
  }
  return input.tappedEmoji;
}
